// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__kNd15","question":"Question_question__h6bGy","description":"Question_description__2iM7Z"};